(function () {
    'use strict';
    angular
        .module('app')
        .controller('inputBox', inputBox);
    inputBox.$inject = ['$rootScope', '$scope', '$mdDialog', 'loginService'];
    function inputBox($rootScope, scope, $mdDialog, loginService) {
        scope.loginService = loginService;

        // Initialized in inputBoxShow.
        scope.inputBox = $rootScope.inputBox;

        scope.sendEvents = function (bOK) {
            // If there is a PRE event.
            if (scope.inputBox.preClosePromiseCallback != null) {
                // Fire the PRE event.
                scope.inputBox.preClosePromiseCallback($rootScope.inputBox.param1, $rootScope.inputBox.param2, bOK, $rootScope.inputBox.edit1, $rootScope.inputBox.edit2).then(function (data) {
                    // Close the dialog.
                    $mdDialog.hide();
                    // Fire the POST event.
                    if (scope.inputBox.postCloseCallback != null)
                        scope.inputBox.postCloseCallback($rootScope.inputBox.param1, $rootScope.inputBox.param2, bOK, $rootScope.inputBox.edit1, $rootScope.inputBox.edit2);
                }, function (response) {
                    // no-op. Keep the dialog open.
                });
            }
            else {
                // Close the dialog.
                $mdDialog.hide();
                // Fire the POST event.
                if (scope.inputBox.postCloseCallback != null)
                    scope.inputBox.postCloseCallback($rootScope.inputBox.param1, $rootScope.inputBox.param2, bOK, $rootScope.inputBox.edit1, $rootScope.inputBox.edit2);
            }
        }

        scope.onInputBoxOK = function () {
            scope.sendEvents(true);
        }

        scope.onInputBoxCancel = function () {
            scope.sendEvents(false);
        }

        function activate() { }
        activate();
    }
})();
